import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { AssessorsRegistrationTable } from 'components/sections/assessors'
import { FilterAssessorAccountRegistrations } from 'containers/filters'
import { AssessorInvite } from 'containers/forms/assessors'
import { apiAssessors } from 'helpers/decorators/api'
import { meta, permissions } from 'helpers/decorators'
import { connect } from 'react-redux'
import { modal } from '../../../redux/modules/app'
import { FormattedMessage } from 'react-intl'

@meta({
  title: 'Assessors',
  intlKey: 'route.assessors'
})
@permissions()
@apiAssessors({
  listAccountRegistrations: true,
  filter: 'pendingAssessorAccounts'
})
@connect(
    () => ({}),
    { modal }
)
class AssessorsAccountRegistration extends Component {
  static propTypes = {
    inviteAssessor: PropTypes.func.isRequired
  }

  render() {
    return (
      <div>
        <div style={{ padding: "10px"}}>
          <FormattedMessage
            className="control-label"
            id="label.assessor_pending_registration_desc"
            defaultMessage="Assessor pending registration description"
          />
        </div>
        <div>
        <AssessorInvite inviteAssessor={this.props.inviteAssessor} />
        <FilterAssessorAccountRegistrations />
        <AssessorsRegistrationTable {...this.props} isAccountRegistration={true} />
        </div>
      </div>
    )
  }
}

export default AssessorsAccountRegistration
